import React, { useEffect } from 'react'

import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { ListGroup, Col, Row, ListGroupItem } from 'reactstrap'
import './styles/style.scss'
import { useRouteMatch } from 'react-router'

function PracticeReportsLanding(props) {
  const { params } = useRouteMatch()

  return (
    <Row>
      <Col className="dashboard-container margin-top-40">
        <ListGroup className="landingList">
          <Link
            to={`/practice-reports/${params.taxId}/dashboard`}
            className={!props.assignedMembers.length ? 'disabled-link' : ''}
          >
            Assigned Member Dashboard
            <span className="icon icon-chevron-right" />
          </Link>
        </ListGroup>
        <ListGroup className="reports-list">
          <h4 className="reportheader">Reports</h4>
          <ListGroupItem>No reports yet.</ListGroupItem>
        </ListGroup>
      </Col>
    </Row>
  )
}

const mapStateToProps = state => ({
  assignedMembers: state.practiceReports.assignedMembers,
})

export default connect(mapStateToProps, null)(PracticeReportsLanding)
